import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import ParadigmaDatePicker from '../../../components/ParadigmaDatePicker/ParadigmaDatePicker';
import api from "../../../api/api";
import apifunctions from "../../../api/functions";
import {Row, Col, Card, CardBody, CardTitle,} from 'reactstrap';

const defaultLoteoOptions = [{'id':0, full_name:"TODOS"}]

const FiltrosResumen = (props) =>{

    const [loteosOptions, setLoteosOptions] = useState(defaultLoteoOptions);

    const {desde, hasta, loteoId, onChange} = props;

    useEffect(()=>refreshLoteos(),[]);

    const refreshLoteos = () =>{
        apifunctions.get(
            api.inversionista.loteos, null, 1, null,
            (data) => setLoteosOptions(defaultLoteoOptions.concat(data.data)),
            (e) => setLoteosOptions(defaultLoteoOptions),
            (e)=> setLoteosOptions(defaultLoteoOptions),
        )
    }

    return( 
        <Col className="col-12">
            <Card body className="border-0 p-0 m-0">
                <CardTitle className="text-center py-2 mb-0 col-color">Filtros</CardTitle>
                <CardBody>
                    <Row>
                        <Col className="col-12 col-md-4">
                        <ParadigmaLabeledInput
                            label="Período"
                            md={[3, 9]}
                            inputComponent={
                                <Row>
                                    <Col className="col-6 col-md-12 col-lg-12 col-xl-6 mb-0 mb-md-1 mb-xl-0 pr-1">
                                        <ParadigmaDatePicker fieldName={"fechaInicio"}
                                            datetime={false}
                                            placeholder={"Desde"}
                                            icon={"fa fa-calendar"}
                                            value={desde}
                                            onChange={data => onChange('desde', data)}
                                        />
                                    </Col>
                                    <Col className="col-6 col-md-12 col-lg-12 col-xl-6 pl-1">
                                        <ParadigmaDatePicker fieldName={"fechaFin"}
                                            datetime={false}
                                            placeholder={"Hasta"}
                                            icon={"fa fa-calendar"}
                                            value={hasta}
                                            onChange={data => onChange('hasta', data)}
                                        />
                                    </Col>
                                </Row>
                            }
                            />
                        </Col>
                        <Col className="col-12 col-md-4">
                            <ParadigmaLabeledInput
                                md={[3, 9]}
                                label={"Loteos"}
                                inputComponent={
                                    <Select
                                        clearable={false}
                                        backspaceRemoves={true}
                                        value={loteoId}
                                        onChange={(value) => onChange('loteoId', value.id)}
                                        valueKey={'id'}
                                        labelKey={'full_name'}
                                        options={loteosOptions} 
                                    />
                                }
                            />
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </Col>
    )
 }

export default FiltrosResumen;


// WEBPACK FOOTER //
// ./src/views/Inversionistas/Resumen/FiltrosResumen.js